import { bus } from "@/main";
import { getExhibitionEntry } from "../../../data/models/exhibition.model";
import { getArticleEntry } from "../../../data/models/article.model";

export default {
	name: "ExhibitionPage",
	data() {
		return {
			isReady: false,
			content: [],
			language: this.$route.params.lang,
			name: this.$route.name,
			openSection: 0,
			url: window.location.href
		}
	},
	props: {},
	created() {
		this.getContent();
		bus.$emit("hideTitle", false);
	},
	watch: {
		$route: function() {
			this.getContent();
			this.language = this.$route.params.lang;
			this.url = window.location.href;
		}
	},
	computed: {
		pageUrl: function () {
			return location.href;
		}
	},
	methods: {
		getContent(){
			let contentReady = new Promise ((resolve, reject) => {
				getExhibitionEntry(this.$route.params.exhibition, "slug", 4).then(
					content => {
						this.content = null
						this.content = content
						this.isReady = true
						resolve(true)
					}
				);
			})
			Promise.all([contentReady]).then(() => {
				bus.$emit("evalColors", true);
				bus.$emit("PAGE_IS_READY", true);
			})
		},
		nextSection() {
			const exhibitionEl = document.getElementById("exhibition");
			exhibitionEl.scroll({
				left: (exhibitionEl.offsetWidth / 2) * (this.openSection + 1),
				behavior: 'smooth'
			});
			if (this.openSection < 1)
				this.openSection = this.openSection + 1;
			setTimeout(() => {
				bus.$emit("evalColors", true);
				bus.$emit("hideTitle", true);
			}, 300);
		},
		prevSection() {
			const exhibitionEl = document.getElementById("exhibition");
			exhibitionEl.scroll({
				left: (exhibitionEl.offsetWidth / 2) * (this.openSection - 1),
				behavior: 'smooth'
			});
			this.openSection = this.openSection - 1;
			setTimeout(() => {
				bus.$emit("evalColors", true);
				bus.$emit("hideTitle", false);
			}, 100);
		},
		evalScroll() {
			let element = document.querySelector(".exhibition__content__c")
			let controller = document.querySelector(".exhibition__controls__next")

			if (this.openSection == 0) {
				if ( element.scrollTop + window.innerHeight == element.scrollHeight)
					controller.classList.add("scroll-animation")
				else
					controller.classList.remove("scroll-animation")
			}
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/exhibition/exhibition.page.js